import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import Logo from "../components/Logo";

const INK = "#14101F";
const CREAM = "#F5F2EC";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    if (password !== confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please log in");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ fontFamily: "Inter, sans-serif", color: INK, minHeight: "100vh", background: CREAM, display: "grid", placeItems: "center", padding: 24 }}>
      <div className="sc-card-lg" style={{ width: "100%", maxWidth: 420, padding: 32 }}>
        <Logo height={64} />
        <h1 style={{ fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: 26, margin: "16px 0 6px", textTransform: "uppercase" }}>New password</h1>
        {!token ? (
          <>
            <p data-testid="reset-notoken" style={{ color: "#b23b1e", fontSize: 14 }}>This reset link is invalid or missing its token.</p>
            <Link to="/forgot-password" className="sc-btn sc-btn-violet" style={{ marginTop: 18, padding: "10px 22px", fontSize: 14 }}>Request a new link</Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <p style={{ color: "#6a6478", fontSize: 14, margin: "0 0 16px" }}>Choose a new password for your account.</p>
            <input data-testid="reset-password" className="sc-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" style={{ marginBottom: 12 }} />
            <input data-testid="reset-confirm" className="sc-input" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm password" />
            <button data-testid="reset-submit" type="submit" disabled={busy} className="sc-btn sc-btn-violet" style={{ width: "100%", marginTop: 16, padding: 13, fontSize: 15 }}>
              {busy ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
